import React, { useState } from "react";
import { Outlet } from "react-router-dom";
import { Navigation } from "./Navigation";
import SearchBox from "./SearchBox";
import Footer from "./Footer";

export default function BlogLayout() {
  const [showSearch, setShowSearch] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <Navigation onSearchClick={() => setShowSearch(!showSearch)} />
      {showSearch && (
        <div className="max-w-3xl mx-auto px-4 py-3">
          <SearchBox />
        </div>
      )}
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <Outlet />
      </div>

      <Footer />
    </div>
  );
}
